<template>
  <el-row class="pcd-row">
    <el-col :span="4">
      <div title="拖拽到右侧灰色区域" class="pcd-components" v-loading="loading">
        <div :data-pc-name="config.name" draggable="true" @dragstart.stop="onDragStart" @dragend.stop="onDragEnd" :title="config.text" @dblclick="showDemo(config.demo)" v-for="config in configs" :key="config.name" v-if="config.apiType !== 'interface'">
          <span :class="endpoint + '-demo-icon'" v-html="config.icon"></span>
          <p>{{config.text}}</p>
        </div>
      </div>
    </el-col>
    <el-col :span="device === 'MOBILE' ? 9 : 14">
      <root-component :endpoint="endpoint" :group="group" :device="device" @select="onSelect" ref="root"></root-component>
    </el-col>
    <el-col :span="device === 'MOBILE' ? 11 : 6" v-if="sc">
      <div class="pcd-settings">
        <div class="pcd-settings-title">{{sc.config.name}} - {{sc.config.text}}</div>
        <el-collapse v-model="activeProperty">
          <el-collapse-item v-if="sc.config.properties" name="properties">
            <p class="pcd-settings-subtitle" slot="title">基础</p>
            <property-field :endpoint="endpoint" :property="p" :uiId="uiId" :label="getLabel(p, 'property')" @change="onValueChange(p, 'properties')" v-for="p in sc.config.properties" :dfTablecolumns="dfTablecolumns" :key="p.name"></property-field>
          </el-collapse-item>
          <el-collapse-item v-if="sc.config.advancedProperties" name="advancedProperties">
            <p class="pcd-settings-subtitle" slot="title">高级</p>
            <property-field :endpoint="endpoint" :property="p" :uiId="uiId" :label="getLabel(p, 'advancedProperty')"  @change="onValueChange(p, 'advancedProperties')" v-for="p in sc.config.advancedProperties" :key="p.name"></property-field>
          </el-collapse-item>
          <el-collapse-item v-if="sc.config.methods" name="methods">
            <p class="pcd-settings-subtitle" slot="title">方法</p>
            <property-field :endpoint="endpoint" :property="p" :uiId="uiId" :label="getLabel(p, 'method')"  @change="onValueChange(p, 'methods')" v-for="p in sc.config.methods" :key="p.name"></property-field>
          </el-collapse-item>
          <el-collapse-item v-if="sc.config.events" name="events">
            <p class="pcd-settings-subtitle" slot="title">事件</p>
            <property-field :endpoint="endpoint" :property="p" :uiId="uiId" :label="getLabel(p, 'event')"  @change="onValueChange(p, 'events')" v-for="p in sc.config.events" :key="p.name"></property-field>
          </el-collapse-item>
          <el-collapse-item v-if="sc.config.hooks" name="hooks">
            <p class="pcd-settings-subtitle" slot="title">钩子</p>
            <property-field :endpoint="endpoint" :property="p" :uiId="uiId" :label="getLabel(p, 'hook')"  @change="onValueChange(p, 'hooks')" v-for="p in sc.config.hooks" :key="p.name"></property-field>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { loadConfigApi, translateConfigs, getDevice } from './util.js'
import RootComponent from './components/RootComponent'
import PropertyField from './field/PropertyField'

export default {
  name: 'design-area',
  components: {
    RootComponent,
    PropertyField
  },
  props: {
    uiId: { type: Number, required: true },
    endpoint: { type: String, required: true },
    group: { type: String, required: true },
    dfTablecolumns: { type: Array, required: false }
  },
  data () {
    return {
      device: '',
      loading: false,
      configs: [],
      sc: null,
      activeProperty: ['properties']
    }
  },
  created () {
    this.device = getDevice(this.endpoint)
  },
  watch: {
    endpoint () {
      this.device = getDevice(this.endpoint)
    }
  },
  methods: {
    init (configJson) {
      this.loading = true
      loadConfigApi(this.endpoint, this.group, (configs) => {
        this.loading = false
        this.configs = configs
        this.initRootComponent(configJson)
      })
    },
    initRootComponent (configJson) {
      if (configJson) {
        this.$refs.root.setChildren(translateConfigs(this.endpoint, this.group, configJson))
        this.sc = null
      } else {
        this.$refs.root.setChildren([])
        this.sc = null
      }
    },
    getLabel (p, type) {
      if (type === 'method') {
        return p.text ? (p.name + '() - ' + p.text) : (p.name + '()')
      }
      if (type === 'event' || type === 'hook') {
        return p.text ? (p.name + ' - ' + p.text) : p.name
      }
      return p.text || p.name
    },
    onValueChange (property, field) {
      this.sc.changeProperty(property, field)
    },
    hasConfig () {
      let config = this.$refs.root.getConfig()
      return !!config && !!config.length
    },
    getConfig (getValueType) {
      let config = this.$refs.root.getConfig(getValueType)
      if (!config || !config.length) {
        return null
      }
      return config
    },
    onDragStart (e) {
      e.dataTransfer.effectAllowed = 'copy'
      e.dataTransfer.setData('data', JSON.stringify({
        name: e.target.getAttribute('data-pc-name')
      }))
    },
    onDragEnd (e) {
      e.dataTransfer.clearData('data')
    },
    onSelect (component) {
      if (this.sc === component) {
        return
      }

      if (this.sc) {
        this.sc.changeSelected(false)
        this.sc.$off('beforeDestroy', this.onRemove)
      }

      this.sc = component
      this.sc.$on('beforeDestroy', this.onRemove)
      this.sc.changeSelected(true)
    },
    onRemove () {
      this.sc = null
    },
    showDemo (url) {
      if (url) {
        window.open(url)
      } else {
        alert('暂无示例')
      }
    }
  }
}
</script>

<style>
.pcd-row{height:calc(100vh - 59px);}
.pcd-row>.el-col{height:100%;overflow-y:scroll;}
.pcd-components{padding:10px 10px 0 10px;box-sizing:border-box;display:flex;flex-wrap:wrap;justify-content:space-between;}
.pcd-components>div{width:48%;padding:4px 0;margin-bottom:10px;text-align:center;border-radius:4px;border:1px dashed #ccc;box-sizing:border-box;cursor:move;user-select:none;}
.pcd-components>div>p{font-size:12px;line-height:12px;color:#8492a6;margin-top:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.pcd-settings{margin:10px 10px 0 10px;border:1px solid #ebeef5;border-radius:8px;box-sizing:border-box;user-select:none;}
.pcd-settings .el-collapse-item__content{background:#f1f1f1;padding-bottom:0.1px;}
.pcd-settings-title{padding:10px 0 10px 10px;font-weight:500;}
.pcd-settings-subtitle{padding-left:10px;}

@font-face {
  font-family: vux-demo;
  src: url(//at.alicdn.com/t/font_70323_wlronpvr565yiudi.eot);
  src: url(//at.alicdn.com/t/font_70323_wlronpvr565yiudi.eot#iefix) format("embedded-opentype"),url(//at.alicdn.com/t/font_70323_wlronpvr565yiudi.woff) format("woff"),url(//at.alicdn.com/t/font_70323_wlronpvr565yiudi.ttf) format("truetype"),url(//at.alicdn.com/t/font_70323_wlronpvr565yiudi.svg#iconfont) format("svg")
}
.vux-demo-icon{font-family:vux-demo;font-size:28px;color:#04be02}
.vux-demo-icon:before{content:attr(icon)}

@font-face {
  font-family: 'iconfont';
  src: url('//at.alicdn.com/t/font_822034_br21332am6u.eot');
  src: url('//at.alicdn.com/t/font_822034_br21332am6u.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_822034_br21332am6u.woff') format('woff'),
  url('//at.alicdn.com/t/font_822034_br21332am6u.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_822034_br21332am6u.svg#iconfont') format('svg');
}
.element-ui-demo-icon{font-family:iconfont;font-size:28px;color:#409eff}
.element-ui-demo-icon:before{content:attr(icon)}
.selectedColumn{color: #bbbbbb}
</style>
